window.addEventListener('DOMContentLoaded', function(){

    let altProgress = document.querySelector('.dtc-alt-progress');
    if (altProgress){

        let cart = altProgress.dataset.cart;
        let free_gift_threshold = altProgress.getAttribute('free_gift_threshold');
        let free_gift_id = altProgress.getAttribute('free_gift_id');
        let { total_weight, total_price, item_count } = cart;

        adjustProgressBar(total_price, total_weight, item_count, free_gift_threshold);

        subscribe(PUB_SUB_EVENTS.cartRender, (data) => {
            const { total_price, total_weight, item_count, items } = data.cart;
            adjustProgressBar(total_price, total_weight, item_count, free_gift_threshold);
            checkIfFreeGift(total_price, items, free_gift_threshold, free_gift_id);
        });
    }
});

function adjustProgressBar(price, weight, items, threshold){
    const total_weight = weight * 0.00220462;
    const priceThreshold = threshold;
    const weightThreshold = 3.39;
    const altProgress = document.querySelector('.dtc-alt-progress');
    const altProgressBar = altProgress.querySelector('.bg-progressFilled');
    const altProgressMsg = altProgress.querySelector('.free-shipping-text p');
    const freeShippingBreakpoint = altProgress.querySelector('.shipping-breakpoint');
    const freeGiftBreakpoint = altProgress.querySelector('.gift-breakpoint');
    const freeGiftTitle = altProgress.getAttribute('free_gift_title');
    const shopCta = document.querySelector('.shop-cta');
    let freeShipping = total_weight >= weightThreshold;
    let freeGift = price >= priceThreshold;
    let progress = 0;
    let message = '';

    if (!freeShipping && total_weight > 0) {
        progress = total_weight > weightThreshold ? 40 : 20;
    } else if (items < 2) {
        progress = 40;
    } else {
        progress = price < priceThreshold ? ((price / priceThreshold) * 60) + 40 : 100;
        freeGift = progress === 100;
    }

    if (total_weight < weightThreshold){
        message = 'Add 1 More Item for Free Shipping';
    } else if (freeShipping && price < priceThreshold){
        message = `Add $${(priceThreshold - price) / 100} to unlock a FREE ${freeGiftTitle}`;
    } else {
        message = `You’ve unlocked a FREE ${freeGiftTitle} 🎉`;
    }

    shopCta.classList.toggle('hidden', freeGift);
    altProgressBar.style.transitionProperty = "width";
    altProgressBar.style.width = `${progress}%`;
    altProgressBar.offsetHeight;
    freeGiftBreakpoint.classList.toggle('unlocked', freeGift);
    freeShippingBreakpoint.classList.toggle('unlocked', freeShipping);

    const updateIcon = (element, condition) => {
        const textElement = element.querySelector('p');
        const text = textElement.innerText;
        if (condition){
            if (!text.endsWith('🎉')) textElement.innerText = `${text}🎉`;
        } else {
            if (text.endsWith('🎉')) textElement.innerText = text.replace('🎉', '');
        }
    }

    updateIcon(freeShippingBreakpoint, freeShipping);
    updateIcon(freeGiftBreakpoint, freeGift);

    altProgressMsg.innerText = message;
}

function checkIfFreeGift(price, items, threshold, free_gift_id){
    let priceThreshold = threshold;
    let freeGiftID = free_gift_id;
    let freeGift = price >= priceThreshold;
    let lineItemGift = items.find(item => item.properties._free_gift === true);
    let giftInCart = lineItemGift !== undefined;

    if (freeGift && !giftInCart){
        addFreeGift(true, freeGiftID, '');
    } else if (!freeGift && giftInCart){
        addFreeGift(false, '', lineItemGift.key);
    }
}

async function fetchCart(URL, body){
    await fetch(`${URL}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
    .then(response => response.json())
    .then(() => {
        window.BIRTHDATE_CART.refreshCart();
    })
    .catch(error => console.error('Error:', error));
}

function addFreeGift(freeGiftApply, freeGiftID, freeGiftLineKey){
    if (freeGiftApply){
        let formData = {
            items: [
                {
                    quantity: 1,
                    id: freeGiftID,
                    properties: {
                        '_free_gift': true
                    },
                },
            ],
        }

        fetchCart(routes.cart_add_url, formData);
    } else {
        let updates = {
            [freeGiftLineKey]: 0
        }

        fetchCart(routes.cart_update_url, {updates});
    }
}